import { HttpInterceptorFn } from '@angular/common/http';

const AUTH_URLS = ['/auth/login', '/auth/register'];
const REFRESH_URLS = ['/auth/logout', '/auth/refresh'];
const TOKEN_KEY = 'token';
const REFRESH_KEY = 'refresh';

export const mainInterceptor: HttpInterceptorFn = (req, next) => {
  const url = req.url.toLowerCase();

  if (AUTH_URLS.some(path => url.endsWith(path))) {
    return next(req);
  }

  const headers: Record<string, string> = {};

  if (REFRESH_URLS.some(path => url.includes(path))) {
    const refreshToken = localStorage.getItem(REFRESH_KEY);
    if (refreshToken) headers['X-Refresh-Token'] = refreshToken;
  } else {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) headers['Authorization'] = token;
  }
  return headers
    ? next(req.clone({ setHeaders: headers }))
    : next(req);
};
